import { styles } from './template.scss';
import { styles as styleHelpers } from '../../../assets/style-helpers.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { FontSizes, FontWeights } from '../../../types/common/types';

export const templatePhasrBehavioralProfilesComponent = document.createElement('template');

templatePhasrBehavioralProfilesComponent.innerHTML = `
  <style>${styleHelpers}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class='wrapper'>
    <div class='loading-container'>
      <gz-progress-spinner size='large'></gz-progress-spinner>
    </div>
    <div class='content-wrapper'>
      <gz-title fontSize="${FontSizes.HEADING_4}" class="mt-3 mb-1" fontWeight="${FontWeights.MEDIUM}" id="behavioralProfilesTitle"></gz-title>
      <gz-info-box class='hidden' id='infoBox'></gz-info-box>
      <gz-single-select id="phasrProfileTypeSelector" class="mb-1 mt-1 hidden" labelWidth='240'></gz-single-select>
      <gz-single-select-complex id='phasrSearchUsers' labelWidth='240' class="mb-1"></gz-single-select-complex>
      <gz-phasr-restricted-profiles-view></gz-phasr-restricted-profiles-view>
    </div>
  </div>
`;
